/**
 * @generated SignedSource<<9b998f5c6f50704be68446c7186d6dd3>>
 * @relayHash e4ead81ee7c6877a39b945c144d5b88d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d904dd3db72a8f1b24d2188caa46866b82260b25af451f2e31c5859a9688c053

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { WorkItemEntrypointUiQuery } from './WorkItemEntrypointUiQuery.graphql';

const node: PreloadableConcreteRequest<WorkItemEntrypointUiQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "d904dd3db72a8f1b24d2188caa46866b82260b25af451f2e31c5859a9688c053",
    "metadata": {},
    "name": "WorkItemEntrypointUiQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
